// Fetch con errori leggibili: il backend legacy risponde {"error": "..."},
// FastAPI/OmniSurv {"detail": "..."}.

export class HttpError extends Error {
  constructor(status, message) {
    super(message);
    this.status = status;
  }
}

async function toError(res, fallback) {
  let message = fallback;
  try {
    const body = await res.json();
    if (typeof body.error === "string") message = body.error;
    else if (typeof body.detail === "string") message = body.detail;
  } catch {
    /* corpo non JSON: resta il messaggio generico */
  }
  return new HttpError(res.status, message);
}

export async function getJson(url, { headers, signal } = {}) {
  const res = await fetch(url, { headers, signal });
  if (!res.ok) throw await toError(res, `Errore ${res.status}`);
  return res.json();
}

export async function postJson(url, body, { headers, signal } = {}) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify(body),
    signal,
  });
  if (!res.ok) throw await toError(res, `Errore ${res.status}`);
  return res.json();
}

export function downloadBlob(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}

// Esegue fn su ogni elemento con al più `limit` richieste in parallelo,
// mantenendo l'ordine; un elemento in errore diventa null.
export async function mapLimit(items, limit, fn, onProgress) {
  const out = new Array(items.length);
  let next = 0;
  let done = 0;
  const worker = async () => {
    while (next < items.length) {
      const i = next++;
      try {
        out[i] = await fn(items[i], i);
      } catch {
        out[i] = null;
      }
      done += 1;
      onProgress?.(done / items.length);
    }
  };
  await Promise.all(Array.from({ length: Math.min(limit, items.length) }, worker));
  return out;
}

// POST che restituisce un file (PDF, DXF) e lo scarica.
export async function postForDownload(url, body, filename, { headers, fallbackError } = {}) {
  const res = await fetch(url, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...headers },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw await toError(res, fallbackError || `Errore ${res.status}`);
  downloadBlob(await res.blob(), filename);
}
